import { useEffect } from 'react';

var useWindowListener = function useWindowListener(type, callback) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  useEffect(function () {
    if (condition) {
      window.addEventListener(type, callback);
      return function () {
        window.removeEventListener(type, callback);
      };
    }
  }, [callback, condition, type]);
};

export { useWindowListener as default };
//# sourceMappingURL=index.js.map
